// import { red } from '@material-ui/core/colors';
import { makeStyles } from '@material-ui/core/styles';
// import colors from 'global/styles/colors';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    height: 'calc(100% - 64px)',

    [theme.breakpoints.down('lg')]: {
      position: 'relative',
      height: 'auto',
    },

    '& .MuiTab-labelIcon': {
      minHeight: 50,
    },

    '@media print': {
      position: 'relative',
    },

    '& .content': {
      padding: theme.spacing(2),

      '& .buttonRow button': {
        margin: theme.spacing(1),
      },
    },
  },
  questionsContainer: {
    maxWidth: '1040px',
    margin: 'auto',

    '& .assessmentContainer': {
      width: '100%',
      position: 'absolute',
      left: 0,
      right: 0,
      top: 0,
      bottom: (p) => (p.isMobile ? undefined : 0),
      overflow: 'hidden',
      overflowY: 'auto',
    },

    '& .assessmentTitle': {
      margin: theme.spacing(2),
    },

    '&.resultsContainer': {
      maxWidth: '1040px',
      margin: `${theme.spacing(2)}px ${theme.spacing(2)}px`,

      '& .questionContainer': {
        width: (p) => (p.isMobile ? '100%' : '40%'),
      },

      '& .answerContainer': {
        width: (p) => (p.isMobile ? '80%' : '50%'),
        maxWidth: 500,
        margin: theme.spacing(2),
        padding: theme.spacing(1),
        backgroundColor: theme.palette.action.disabledBackground,
        borderRadius: theme.spacing(1),
      },

      '& .question': {
        flex: 1,
        maxWidth: 500,
        margin: `${theme.spacing(5)}px 0`,
        minHeight: 'auto',
      },

      '& .showAnswer': {
        '& .checkpointOption': {
          backgroundColor: theme.palette.action.disabledBackground,
          margin: `${theme.spacing(1)}px ${theme.spacing(1)}px 0 0`,
          padding: `${theme.spacing(0.5)}px ${theme.spacing(1)}px`,

          '&.incorrect': {
            '&.selected': {
              backgroundColor: theme.colors.danger,
            },

            '& .MuiIcon-root': {
              color: theme.colors.danger,
            },
          },
          '&.correct': {
            '&.selected': {
              backgroundColor: theme.colors.success,
            },

            '& .MuiIcon-root': {
              color: theme.colors.success,
            },
          },

          '& .MuiIcon-root': {
            padding: theme.spacing(1),
          },

          '&.selected.incorrect .MuiIcon-root, &.selected.correct .MuiIcon-root': {
            color: theme.colors.white,
          },
        },
      },
    },

    '& .buttonContainer': {
      position: (p) => (p.isMobile ? 'fixed' : 'absolute'),
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 1100,
    },

    '& .buttonRow': {
      width: '100%',
      '& button': {
        margin: theme.spacing(1),
      },
    },

    '& .prog': {
      width: (p) => (p.isMobile ? '95%' : '100%'),
      maxWidth: 500,
    },
    '& .question': {
      maxWidth: 500,
      margin: '0 auto',
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),

      '&.assessmentEnd': {
        textAlign: 'center',
        '& .submitRow': {
          flexDirection: 'column',

          '& .btn': {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
            width: 250,
            textAlign: 'center',

            '& button': {
              margin: theme.spacing(1),
            },
          },
        },
      },

      '&.intro': {
        textAlign: 'center',
        minHeight: undefined,

        '& .header': {
          paddingTop: theme.spacing(3),
        },
      },

      '& .submitRow': {
        marginTop: theme.spacing(2),
      },

      '& .header': {
        marginBottom: theme.spacing(2),
      },
      '& .options': {
        margin: theme.spacing(2),

        '&.boolean': {
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',

          '& .checkpointOption': {
            paddingRight: theme.spacing(2),
          },
        },
      },
      '& .checkpointOption': {
        borderRadius: theme.spacing(1),
        '&:hover': {
          backgroundColor: (p) => (p.isMobile ? undefined : theme.palette.action.disabledBackground),
          cursor: 'pointer',
        },
      },
    },
  },
}));

export default useStyles;
